import { ENGINE_MATCHER_ALL } from '../../logger/constants';
export function allMatcherContext(log) {
    return function allMatcher(runtimeAttr) {
        log.debug(ENGINE_MATCHER_ALL);
        return runtimeAttr != null;
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/evaluator/matchers/all.js
// module id = 1551
// module chunks = 29